import React, { createContext, useContext, useReducer, useCallback } from "react";

const ToastContext = createContext(null);

function toastReducer(state, action) {
  switch (action.type) {
    case "ADD_TOAST":
      return [...state, action.toast];
    case "REMOVE_TOAST":
      return state.filter((t) => t.id !== action.id);
    default:
      return state;
  }
}

const typeColors = {
  success: { background: "#1a1715", color: "#4ade80",  border: "2px solid #4ade80" },
  error:   { background: "#1a1715", color: "#ff5a1f",  border: "2px solid #ff5a1f" },
  info:    { background: "#1a1715", color: "#f2ece1",  border: "2px solid #403c37" },
  saving:  { background: "#1a1715", color: "#ff5a1f",  border: "2px solid #ff5a1f" },
};

export function ToastProvider({ children }) {
  const [toasts, dispatch] = useReducer(toastReducer, []);

  const addToast = useCallback((message, type = "info", duration = 3000) => {
    const id = `${Date.now()}-${Math.random()}`;
    dispatch({ type: "ADD_TOAST", toast: { id, message, type } });
    if (duration > 0) {
      setTimeout(() => dispatch({ type: "REMOVE_TOAST", id }), duration);
    }
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    dispatch({ type: "REMOVE_TOAST", id });
  }, []);

  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      {children}
      <div
        style={{
          position: "fixed",
          bottom: 24,
          right: 24,
          display: "flex",
          flexDirection: "column",
          gap: 8,
          zIndex: 9999,
          pointerEvents: "none",
        }}
      >
        {toasts.map((toast) => (
          <div
            key={toast.id}
            style={{
              padding: "10px 16px",
              boxShadow: "4px 4px 0 #ff5a1f",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "0.78rem",
              fontWeight: 400,
              minWidth: 220,
              maxWidth: 340,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
              pointerEvents: "auto",
              ...typeColors[toast.type],
            }}
          >
            <span>{toast.message}</span>
            <button
              onClick={() => removeToast(toast.id)}
              style={{
                background: "none",
                border: "none",
                color: "inherit",
                cursor: "pointer",
                fontSize: 18,
                padding: 0,
                lineHeight: 1,
                opacity: 0.8,
                flexShrink: 0,
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within a ToastProvider");
  return ctx;
}
